import React from "react";
import Banner from "../components/Banner";
import { Sidebar } from "../components/Sidebar";
import axios from "axios";
import Spinner from "../components/Spinner";
import { Chart, registerables } from "chart.js";
import { Bar, Pie } from "react-chartjs-2";

Chart.register(...registerables);

const API = localStorage.getItem("assethost");

export default class Dashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      valid: true,
      msg: "",
      toastColor: "",
      // Flattened dashboard state
      totalAssets: 0,
      // AccountStatus flattened
      companyAccountActive: "",
      accountStatusExpiryDate: "",
      subscriptionName: "",
      accountStatusCost: 0,
      // BalanceView flattened
      bundleName: "",
      credits: 0,
      balanceExpiryDate: "",
      balanceCost: 0,
      used: 0,
      // SystemMessages as array of flat objects
      systemMessages: [],
      // ChartDetails as array of flat chart objects
      chartDetails: [],
    };
    this.loadDashboard = this.loadDashboard.bind(this);
    this.safeText = this.safeText.bind(this);
  }

  safeText(v) {
    return v === null || v === undefined || v === "" ? "-" : String(v);
  }

  componentDidMount() {
    this.loadDashboard();
  }

  loadDashboard() {
    const token = sessionStorage.getItem("token");
    const companyProfileId = sessionStorage.getItem("companyProfileId");
    const individualProfileId = sessionStorage.getItem("individualProfileId");
    const lawEnforcementProfileId = sessionStorage.getItem(
      "lawEnforcementProfileId"
    );
    const isPaidService = sessionStorage.getItem("isPaidService");
    if (!token) {
      this.setState({
        loading: false,
        msg: "No user session/token. Please login.",
        toastColor: "danger",
      });
      sessionStorage.clear();
      window.href = `/?redirectUrl=${window.location.pathname + window.location.search
        }`;
      return;
    }

    if (!companyProfileId && !individualProfileId && !lawEnforcementProfileId) {
      this.setState({
        loading: false,
        msg: "No profile ID found. Please login again.",
        toastColor: "danger",
      });
      return;
    }

    const requestBody = {
      companyProfileId: companyProfileId ? parseInt(companyProfileId) : null,
      individualProfileId: individualProfileId
        ? parseInt(individualProfileId)
        : null,
      lawEnforcementProfileId: lawEnforcementProfileId
        ? parseInt(lawEnforcementProfileId)
        : null,
      isPaidService: isPaidService
    };

    axios
      .post(API + "/home/getdashboard", requestBody, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        const data = response.data || {};
        const chartDetails = data.chartDetails || [];
        const accountStatus = data.accountStatus || {};
        const balanceView = data.balanceView || {};
        const systemMessages = data.systemMessages || [];



        // Flatten accountStatus
        const flattenedAccountStatus = {
          companyAccountActive: accountStatus.companyAccountActive || "",
          expiryDate: accountStatus.expiryDate || "",
          subscriptionName: accountStatus.subscriptionName || "",
          cost: accountStatus.cost || 0,
        };

        // Flatten balanceView
        const flattenedBalance = {
          bundleName: balanceView.bundleName || "",
          credits: balanceView.credits || 0,
          expiryDate: balanceView.expiryDate || "",
          cost: balanceView.cost || 0,
          used: balanceView.used || 0,
        };

        this.setState({
          loading: false,
          totalAssets: data.totalAssets || 0,
          companyAccountActive: flattenedAccountStatus.companyAccountActive,
          accountStatusExpiryDate: flattenedAccountStatus.expiryDate,
          subscriptionName: flattenedAccountStatus.subscriptionName,
          accountStatusCost: flattenedAccountStatus.cost,
          bundleName: flattenedBalance.bundleName,
          credits: flattenedBalance.credits,
          balanceExpiryDate: flattenedBalance.expiryDate,
          balanceCost: flattenedBalance.cost,
          used: flattenedBalance.used,
          systemMessages,
          chartDetails: chartDetails,
        });
      })
      .catch((error) => {
        if (Number(error.status) === 403) {
          window.location.href = `/?redirectUrl=${window.location.pathname + window.location.search
            }`;
          sessionStorage.clear();
        }
        this.setState({
          loading: false,
          msg: error?.response?.data?.message || "Failed to load dashboard.",
          toastColor: "danger",
        });
      });
  }
  redirectTo(link) {
    window.location = link
  }
  render() {
    const s = this.state;

    let divMsg = null;
    if (s.msg) {
      divMsg = (
        <div
          className={
            s.toastColor === "success"
              ? "alert alert-success mx-7"
              : "alert alert-danger mx-7"
          }
        >
          {s.msg}
        </div>
      );
    }

    // Render system messages as alerts
    const systemMessagesDivs = s.systemMessages.map((msg, index) => (
     <div className="row"><div className="col"> 
      <div key={index} className="alert alert-danger mx-7 mb-2 h-auto">
        <div className="d-flex justify-content-between w-100">
          <div className="">{msg.message}</div>
          <div className="">{msg.systemMessageType === 'MISSING_IDENTITY_DOCUMENTS' && <button
            type="button"
            className="btn btn-danger"
            onClick={() => this.redirectTo(`/upload-documents?systemMessageType=${encodeURIComponent(msg.systemMessageType)}`)}
          >
            Update Missing Details
          </button>}
            {msg.systemMessageType === 'CERTFICATE_OF_INCORPATION' && <button
              type="button"
              className="btn btn-danger"
              onClick={() => this.redirectTo(`/upload-documents?systemMessageType=${encodeURIComponent(msg.systemMessageType)}`)}
            >
              Update Missing Details
            </button>}

            {msg.systemMessageType === 'CR14' && <button
              type="button"
              className="btn btn-danger"
              onClick={() => this.redirectTo(`/upload-documents?systemMessageType=${encodeURIComponent(msg.systemMessageType)}`)}
            >
              Update Missing Details
            </button>}
            {msg.systemMessageType === 'MISSING_IDENTITY_DOCUMENTS_COMPANY' && <button
              type="button"
              className="btn btn-danger"
              onClick={() => this.redirectTo(`/upload-documents?systemMessageType=${encodeURIComponent(msg.systemMessageType)}`)}
            >
              Update Missing Details
            </button>} {msg.systemMessageType === 'SUBSCRIPTION' && <button
              type="button"
              className="btn btn-danger"
              onClick={() => this.redirectTo('/billing/account')}
            >
              Update Subscription
            </button>} {msg.systemMessageType === 'BALANCE' && <button
              type="button"
              className="btn btn-danger"
              onClick={() => this.redirectTo('/billing/account')}
            >
              Top Up Account
            </button>}
          </div>
        </div>
      </div>
      </div></div>
    ));

    if (s.loading) {
      return <Spinner className="" />;
    }

    return (
      <div className="d-flex vh-100 bg-white">
        <Sidebar />
        <div className="d-flex flex-column flex-grow-1 min-vh-100">
          <Banner title="Dashboard" />
          {divMsg}
          {systemMessagesDivs}
          <div className="d-flex justify-content-center flex-grow-1 overflow-auto rounded-bottom">
            <div className="d-flex w-100 h-100 px-4">
              {/* Charts */}
              <div className="row">
              <div className="col-10">
                 <div className="row">
                {!!s.chartDetails &&
                  !!s.chartDetails.length &&
                  s.chartDetails.map((detail) => (
                    <div
                      className="col-6"
                      key={detail.title}
                    >
                      <div className="mb-4 p-4 bg-light border border-primary rounded">
                        <h3 className="fw-bold text-primary mb-2">
                          {detail.title}
                        </h3>
                        <div className="w-100" style={{ maxWidth: '400px', height: '400px' }}>
                          {detail.chartType === "BAR" ? (
                            <Bar
                              datasetIdKey={detail.title}
                              options={{
                                responsive: true,
                                maintainAspectRatio: false,
                                width: 400,
                                height: 400,
                              }}
                              height={400}
                              width={400}
                              data={detail.chart}
                            />
                          ) : (
                            <Pie
                              datasetIdKey={detail.title}
                              options={{
                                responsive: true,
                                maintainAspectRatio: false
                              }}
                              height={400}
                              width={400}
                              data={detail.chart}
                            />
                          )}
                        </div>
                      </div>
                    </div>
                  ))}
                  </div>
              </div>
              {/* Right stats */}
              <div className="col-2">
                <div className="d-flex gap-1 border-bottom pb-2">
                  <div className="p-4 text-primary-emphasis bg-primary-subtle border border-primary-subtle rounded-3">
                    <div className="text-center"><h3 >{this.safeText(s.totalAssets)}</h3></div>
                    <div className="text-center"><i className="bi bi-bank"></i> <b>Total Assets</b> </div>
                    
                  </div>
                </div>
                {s.credits > 0 && sessionStorage.getItem("isPaidService") === 'YES' && (
                  <div className="d-flex gap-1 border-bottom pb-2">
                    <div className="p-4 text-primary-emphasis bg-primary-subtle border border-primary-subtle rounded-3">
                      <div className="row">
                        <div className="col"><span className="fw-bold">Name:</span>
                          {this.safeText(s.bundleName)} <span className="fw-bold">Available Credits:</span>
                          {this.safeText(s.credits)}</div>
                      </div>
                      <div className="row">
                        <div className="col"><button
                          type="button"
                          className="btn btn-danger"
                          onClick={() => this.redirectTo('/billing/account')}
                        >
                          View Account
                        </button></div>

                      </div>
                    </div>
                  </div>
                )}
                {s.companyAccountActive === 'YES' &&
                  <div className="d-flex gap-1 border-bottom pb-2">
                    <div className="p-4 text-primary-emphasis bg-primary-subtle border border-primary-subtle rounded-3">
                      <div className="row">
                        <div className="col"> <span className="fw-bold">Name:</span>
                          {this.safeText(s.subscriptionName)}  <span className="fw-bold">Expiry:</span>
                          {this.safeText(s.expiryDate)}</div>
                      </div>
                      <div className="row">
                        <div className="col"><button
                          type="button"
                          className="btn btn-danger"
                          onClick={() => this.redirectTo('/billing/account')}
                        >
                          View Account
                        </button></div>

                      </div>
                    </div>
                  </div>
                }
              </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    );
  }
}
